<button class="main" type="text">
  <img
    src="../../../assets/icons/view-icon.png"
    alt="View Chemical Structure"
  />
  {{buttonText}}
</button>
